<template lang="html">
  <div class="d-flex" v-if="currentDataChart">
    <div id="chart" class="m-auto" >
      <apex-chart :key="uniqueId" type="pie" width="620" :options="chartOptions" :series="series" ></apex-chart>
    </div>
  </div>
</template>

<script>


export default {
  props: ['showAmountNotNumber', 'datasetData'],
  data () {
    return {
      chartOptions: {
        labels: [],
        colors: [],

        dataLabels: {
          enabled: false
        }
      },
      series: [],
      backgroundColors: {
        "RTPI-001": '#ff0000',
        "RTPI-002": '#ff00c1',
        "RTPI-003": '#ffad00',
        "RTPI-004": '#e1e100',
        "RTPI-005": '#73ff00',
        "RTPI-006": '#3bb705',
        "RTPI-007": '#00ffd7',
        "RTPI-008": '#006fff',
        "RTPI-009": '#752ae3',
        "RTPI-010": '#6f3503',
        "RTPI-011": '#4b4a4b',
        "OTHER": "#cccccc"
      },
      RTPIData: this.datasetData,
      uniqueId: this.generateUniqueId(),
      currentDataChart: false,
    }
  },
  computed: {
    chartAccessibleLabel () {
      const values = Object.keys(this.datasetData || {})
          .map(key => {
            return `${this.$t('filter.feature.' + key)} : ${this.datasetData[key]}`
          })
          .join(', ')

      return `${this.$t('common.monitoring.following_statistics_from_perimeter')} : ${values}`
    }
  },
  watch: {
    datasetData: {
      handler (newValue) {
        this.makeChartData(newValue)
        this.currentDataChart = true
      }
    },
  },
  created () {
    this.makeChartData(this.datasetData)
    this.currentDataChart = true
  },
  mounted() {
    this.makeChartData(this.datasetData)
    this.currentDataChart = true
  },
  updated () {
    this.hideDecorativeSvgs()
  },
  methods: {
    generateUniqueId() {
      return 'id-' + Math.random().toString(36).substr(2, 9);
    },
    makeChartData (rawData) {
      this.uniqueId = this.generateUniqueId()
      this.currentDataChart = false
      this.chartOptions.labels = []
      this.chartOptions.colors = []
      let data = []
      Object.keys(rawData).forEach(key => {
        this.chartOptions.colors.push(this.backgroundColors[key])
        this.chartOptions.labels.push(this.$t('filter.feature.'+key))
        data.push(rawData[key])
      })
      this.series = data
      return data
    },
    hideDecorativeSvgs () {
      this.$nextTick(() => {
        const mainSvg = this.$el.querySelector('svg.apexcharts-svg')

        if (mainSvg) {
          mainSvg.setAttribute('role', 'img')
          mainSvg.setAttribute('aria-label', this.chartAccessibleLabel)
        }

        this.$el.querySelectorAll('foreignObject span > svg').forEach(svg => {
          svg.setAttribute('aria-hidden', 'true')
          svg.setAttribute('focusable', 'false')
        })
      })
    }
  }
}
</script>
<style>
.chartjs-tooltip {
  z-index: 99999999 !important; /* Force un z-index élevé */
  position: absolute;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  padding: 5px;
  font-size: 12px;
  text-align: center;
}
</style>
